import React, { useState } from "react";
import { Link } from "react-router-dom";
import PasswordAuth from "./PasswordAuth";
import { useLocale } from './LocaleProvider';

export default function LoginModal({ onClose, onAuthenticated }) {
  const { locale } = useLocale();
  const spanish = locale === 'es';
  const [mode, setMode] = useState("login");
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [message, setMessage] = useState("");

  async function requestReset(event) {
    event.preventDefault();
    setBusy(true);
    setMessage("");
    try {
      const response = await fetch("/api/auth/request-password-reset", {
        method: "POST",
        credentials: "same-origin",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });
      const payload = await response.json().catch(() => ({}));
      if (!response.ok) throw new Error(spanish ? 'No fue posible enviar el enlace. Inténtalo de nuevo.' : (payload.error || "Não foi possível enviar o link."));
      setMessage(spanish ? 'Si existe una cuenta con este correo, enviaremos un enlace para restablecer la contraseña.' : "Se este e-mail tiver uma conta, enviaremos um link para redefinir a senha.");
    } catch (error) {
      setMessage(error.message);
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="fixed inset-0 z-[80] flex min-h-dvh items-start justify-center overflow-y-auto bg-[rgba(23,58,84,0.5)] p-4 sm:items-center sm:p-6" role="dialog" aria-modal="true" aria-labelledby="login-title">
      <div className="relative my-auto max-h-[calc(100dvh-2rem)] w-full max-w-md overflow-y-auto sheet p-6 sm:max-h-[calc(100dvh-3rem)] sm:p-7">
        <button type="button" aria-label={spanish ? 'Cerrar inicio de sesión' : 'Fechar login'} onClick={onClose} className="absolute right-5 top-5 flex h-11 w-11 items-center justify-center text-2xl leading-none text-[var(--text-muted)]">×</button>
        {mode === "login" ? (
          <>
            <p className="text-xs font-semibold text-[var(--text-muted)]">{spanish ? 'Acceso seguro' : 'Acesso seguro'}</p>
            <h2 id="login-title" className="mt-3 text-3xl font-semibold text-[var(--primary)]">{spanish ? 'Iniciar sesión' : 'Entrar na minha conta'}</h2>
            <p className="mt-2 text-sm text-[var(--text-muted)]">{spanish ? 'Usa el correo y la contraseña de tu cuenta para abrir tu panel.' : 'Use o e-mail e a senha da sua conta para abrir o dashboard.'}</p>
            <div className="mt-6"><PasswordAuth showOtp={false} onAuthenticated={onAuthenticated} /></div>
            <button type="button" onClick={() => { setMode("forgot"); setMessage(""); }} className="mt-4 min-h-11 w-full text-sm text-[var(--primary)] underline">{spanish ? 'Olvidé mi contraseña' : 'Esqueci minha senha'}</button>
            <Link to="/pro#acesso" onClick={onClose} className="mt-5 block min-h-11 text-center text-sm leading-11 text-[var(--text-muted)] underline">{spanish ? 'Aún no tengo una cuenta — crear gratis' : 'Ainda não tenho conta — criar grátis'}</Link>
          </>
        ) : (
          <>
            <p className="text-xs font-semibold text-[var(--text-muted)]">{spanish ? 'Recuperar acceso' : 'Recuperação de acesso'}</p>
            <h2 id="login-title" className="mt-3 text-3xl font-semibold text-[var(--primary)]">{spanish ? 'Restablecer contraseña' : 'Esqueci minha senha'}</h2>
            <p className="mt-2 text-sm text-[var(--text-muted)]">{spanish ? 'Escribe el correo de tu cuenta. Te enviaremos un enlace para crear una contraseña nueva.' : 'Informe o e-mail da sua conta. Enviaremos um link para criar uma nova senha.'}</p>
            <form onSubmit={requestReset} className="mt-6">
              <label className="block text-sm font-bold text-[var(--primary)]" htmlFor="forgot-email">{spanish ? 'Correo de la cuenta' : 'E-mail da conta'}</label>
              <input id="forgot-email" required type="email" autoComplete="email" value={email} onChange={(event) => setEmail(event.target.value)} placeholder={spanish ? 'tu@correo.com' : 'seu@email.com'} className="input-field mt-2" />
              <button disabled={busy} className="mt-4 min-h-11 w-full rounded-xl bg-[var(--accent)] p-3 font-bold text-[var(--on-accent)] disabled:opacity-60">{busy ? (spanish ? 'Enviando…' : 'Enviando…') : (spanish ? 'Enviar enlace de recuperación' : 'Enviar link de recuperação')}</button>
            </form>
            {message && <p role="status" className="mt-4 text-sm text-[var(--text-muted)]">{message}</p>}
            <button type="button" onClick={() => { setMode("login"); setMessage(""); }} className="mt-4 min-h-11 w-full text-sm text-[var(--primary)] underline">{spanish ? 'Volver al inicio de sesión' : 'Voltar para entrar'}</button>
          </>
        )}
      </div>
    </div>
  );
}
